module.exports = __webpack_public_path__ + "fonts/SpareBank1-Bold-Web.b18b395.woff";